module.exports = __webpack_public_path__ + "static/media/box-up.dd0eafa0.svg";